<script>
	import Container from "./components/Container.svelte";
	import Faq from "./components/Faq.svelte";
	import Footer from "./components/Footer.svelte";
	import Hero from "./components/Hero.svelte";
	import HowItWorks from "./components/HowItWorks.svelte";
	import Intersection from "./components/Intersection.svelte";
	import Message from "./components/Message.svelte";
	import Partnership from "./components/Partnership.svelte";
	import Response from "./components/Response.svelte";
	import Section from "./components/Section.svelte";
	import SectionDecoration from "./components/SectionDecoration.svelte";
	import Title from "./components/Title.svelte";
	import WhatsStoppingYou from "./components/WhatsStoppingYou.svelte";
</script>

<Hero/>

<Section background="bg-1">
	<Container>
		<Partnership/>
	</Container>
</Section>

<Intersection top="bg-1" bottom="bg-3"/>

<Section background="bg-3">
	<Title>How it works</Title>
	<Container>
		<HowItWorks/>
	</Container>
</Section>

<Intersection top="bg-3" bottom="bg-1"/>

<Section background="bg-1">
	<Title>Common misconceptions</Title>
	<Container>
		<WhatsStoppingYou/>
	</Container>
</Section>

<Intersection top="bg-1" bottom="bg-4"/>

<Section background="bg-4">
	<Title>What our users are saying</Title>
	<Container>
		<Response/>
	</Container>
</Section>

<Intersection top="bg-4" bottom="bg-1"/>

<Section background="bg-1">
	<Title>Frequent questions</Title>
	<Container>
		<Faq/>
	</Container>
</Section>

<Intersection top="bg-1" bottom="bg-2"/>

<Section background="bg-2">
	<Title>Our mission</Title>
	<Container>
		<Message/>
	</Container>
</Section>

<Intersection top="bg-2" bottom="a1-b" variant="2"/>

<Section background="a1-b">
	<Title color="accent-1-contrast" max="18">Sign up for free and be the first to know when MenoAge is available.</Title>
	<Container>
		<Footer/>
	</Container>
	<SectionDecoration/>
</Section>